import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RegisterMinorFormService } from './register-minor-form.service';
import { UserSearchStateService } from '../../shared/services/user-search-state.service';
import { getPhonePrefixOptions } from '@shared/utils';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { DYNAMIC_PHONE_DIRECTIVE_CONFIG } from '../../shared/constants/dynamic-phone-directive-config.constants';
import { ACCEPTED_FILE_TYPES } from './constants/accepted-file-types.constant';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  AutocompleteComponent,
  ButtonComponent,
  CcsInputComponent,
  CcsSelectComponent,
  FormMessageComponent,
  InputFileComponent,
  CcsDateComponent,
} from '@shared/components';
import { ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import {
  DynamicPhoneValidationDirective,
  PhoneNumberMaskDirective,
} from '@shared/directives';
import {
  HandleUserSearchDirective,
  HandleAutocompleteOptionClickDirective,
  CloseApplicationModalDirective,
} from '../../shared/directives';
import { RelationshipsToMinorEnum } from '@app/minor-estates/shared/enums';
import { HandleClerkCreateMinorSubmitDirective } from './directives/handle-clerk-create-minor-submit.directive';
import { ClerkCreateMinorFacadeService } from './clerk-create-minor-facade.service';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_NATIVE_DATE_FORMATS,
  NativeDateAdapter,
} from '@angular/material/core';

@Component({
  selector: 'app-clerk-create-minor-form',
  imports: [
    AutocompleteComponent,
    ButtonComponent,
    ReactiveFormsModule,
    HandleUserSearchDirective,
    HandleAutocompleteOptionClickDirective,
    FormMessageComponent,
    DynamicPhoneValidationDirective,
    CloseApplicationModalDirective,
    InputFileComponent,
    HandleClerkCreateMinorSubmitDirective,
    PhoneNumberMaskDirective,
    CcsSelectComponent,
    CcsInputComponent,
    MatSlideToggleModule,
    CcsDateComponent,
  ],
  providers: [
    RegisterMinorFormService,
    ClerkCreateMinorFacadeService,
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
  ],
  templateUrl: './clerk-create-minor-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClerkCreateMinorFormComponent {
  private readonly _formService = inject(RegisterMinorFormService);

  protected readonly form = this._formService.form;

  private readonly _userSearchStateService = inject(UserSearchStateService);

  protected readonly isLoading = this._userSearchStateService.isLoading;

  protected readonly phonePrefixOptions = getPhonePrefixOptions();

  protected formattedUsersByName =
    this._userSearchStateService.formattedSearchedUsersByName;
  protected formattedUsersByEmail =
    this._userSearchStateService.formattedSearchedUsersByEmail;

  protected get isPhonePrefixUS() {
    return this.form.controls.prefixPhone.value === DEFAULT_USA_PHONE_PREFIX;
  }

  protected readonly dynamicPhoneDirectiveConfig =
    DYNAMIC_PHONE_DIRECTIVE_CONFIG;

  protected readonly acceptedFileTypes = ACCEPTED_FILE_TYPES;

  protected readonly isFirm = this._formService.isFirm;

  protected readonly relationshipOptions = [
    {
      value: RelationshipsToMinorEnum.Father,
      label: 'Father',
    },
    {
      value: RelationshipsToMinorEnum.Mother,
      label: 'Mother',
    },
    {
      value: RelationshipsToMinorEnum.Other,
      label: 'Other',
    },
  ];

  protected readonly isOtherRelationship =
    this._formService.isOtherRelationship;
  protected readonly is14OrOlder = this._formService.is14OrOlder;

  protected readonly today = new Date();

  protected minorAgeErrorMessage: ValidationErrors = {
    olderThan: () => 'Minor should be younger than 18 years old.',
  };
}
